// extracted by mini-css-extract-plugin
export default {"dropArea":"ImageInput_dropArea__pKXh+","dropAreaChildren":"ImageInput_dropAreaChildren__AsgJo","text":"ImageInput_text__y5Az1","tint":"ImageInput_tint__X2vwW"};